import { render, staticRenderFns } from "./LessonPage.vue?vue&type=template&id=130fddda&"
import script from "./LessonPage.vue?vue&type=script&lang=js&"
export * from "./LessonPage.vue?vue&type=script&lang=js&"
import style0 from "./LessonPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
installComponents(component, {VBreadcrumbs})
